import ThemeSwitch from "$src/js/components/molecules/header/ThemeSwitch.svelte";
import { mount } from "svelte";

export class ThemeSwitchRender {
    private elements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-switch-theme');

    constructor() {
        this.render();
    }

    render() {
        this.elements.forEach((element) => {
            mount(ThemeSwitch, {
                target: element,
            });
        });
    }
}
